import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzSelectModule } from '@blk/daisy/combinations/dropdown';
import { DzPillsModule } from '@blk/daisy/combinations/filters';
import { DzMicroactionModule } from '@blk/daisy/combinations/microactions';
import { DzNotificationsModule } from '@blk/daisy/combinations/notifications';
import { SearchModule } from '@blk/daisy/combinations/search';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzProgressSpinnerModule } from '@blk/daisy/core/loading';
import { DzPictogramsModule, dzPortfolio } from '@blk/daisy/core/pictograms';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { DzFormFieldModule } from '@blk/daisy/elements/form-field';
import { DzCheckboxModule } from '@blk/daisy/elements/selection-controls';
import { DzCardModule } from '@blk/daisy/modules/cards';
import { DzModalModule } from '@blk/daisy/modules/modals';
import { DzTableModule } from '@blk/daisy/modules/table';
import { AnalyticsModule } from '@ddt-web/analytics';
import { ConfigLayerModule } from '@ddt-web/config-layer';
import { PortfolioTableModule } from '@ddt-web/core';
import { DomModule } from '@ddt-web/dom';
import { WizardModule, WizardStepsModule } from '@ddt-web/elements';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { faAngleLeft, faCheck, faCheckCircle, faInfoCircle, faSearch, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { DirtyPortfolioDialogComponent } from './dirty-portfolio-dialog/dirty-portfolio-dialog.component';
import { PartnerAcknowledgementDialogComponent } from './partner-acknowledgement-dialog/partner-acknowledgment-dialog.component';
import { PartnerPortfoliosDialogComponent } from './partner-portfolios-dialog.component';
import { PartnerSelectionComponent } from './partner-selection';
import { PortfolioEditComponent } from './portfolio-edit/portfolio-edit.component';
import { PortfolioSelectionComponent } from './portfolio-selection/portfolio-selection.component';

@NgModule({
	declarations: [
		PartnerPortfoliosDialogComponent,
		PartnerSelectionComponent,
		PortfolioSelectionComponent,
		PortfolioEditComponent,
		DirtyPortfolioDialogComponent,
		PartnerAcknowledgementDialogComponent
	],
	imports: [
		CommonModule,
		ConfigLayerModule,
		GenericDirectivesModule,
		DzButtonModule,
		DzSelectModule,
		DzIconModule.withIcons(faCheck, faCheckCircle, faAngleLeft, faTimes, faTrash, faSearch, faInfoCircle),
		SearchModule,
		CwpNgFrameworkModule,
		DzMicroactionModule,
		DzNotificationsModule,
		WizardModule,
		WizardStepsModule,
		DzCardModule,
		DzProgressSpinnerModule,
		DzTableModule,
		DzCheckboxModule,
		DzPillsModule,
		FormsModule,
		DzFormFieldModule,
		ReactiveFormsModule,
		DzModalModule,
		DzProgressSpinnerModule,
		DzNotificationsModule,
		PortfolioTableModule,
		NgxSkeletonLoaderModule,
		DzPictogramsModule.register(dzPortfolio),
		AnalyticsModule,
		DomModule
	]
})
export class PartnerPortfoliosModule { }
